import { ErrorResponse } from 'types/form';
import { IScreenOrderItem } from 'utils/buildFlowTransitions';
import { ApiResources, createErrorResponse, getRequestHeaders, getUrl, Methods, processResponse } from './utils';

export interface IScreenOrderResponse {
  contactId: string;
  leadId: string;
  assetId: string | null;
  leadSourceId: string | null;
  cdxPageFlows: IScreenOrderItem[];
  error: {
    message: string;
  } | null;
  isSuccess: boolean | null;
}

export const getScreenOrder = async (metadata: string, signal?: AbortSignal): Promise<IScreenOrderResponse | ErrorResponse> => {
  try {
    const getScreenOrderEndpoint = `${getUrl(ApiResources.getContactByContactId)}/contact/decrypt`;
    const requestBody = {
      metadata,
    };
    const request = {
      method: Methods.post,
      headers: await getRequestHeaders(),
      body: JSON.stringify(requestBody),
      signal
    };
    const screenOrderFromMetadataResponse = await fetch(getScreenOrderEndpoint, request);
    return processResponse(screenOrderFromMetadataResponse);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
